import { render, staticRenderFns } from "./RouteScheduleRowSkeleton.vue?vue&type=template&id=31880cf5&scoped=true&"
import script from "./RouteScheduleRowSkeleton.vue?vue&type=script&lang=js&"
export * from "./RouteScheduleRowSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./RouteScheduleRowSkeleton.vue?vue&type=style&index=0&id=31880cf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31880cf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31880cf5')) {
      api.createRecord('31880cf5', component.options)
    } else {
      api.reload('31880cf5', component.options)
    }
    module.hot.accept("./RouteScheduleRowSkeleton.vue?vue&type=template&id=31880cf5&scoped=true&", function () {
      api.rerender('31880cf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/RouteScheduleRowSkeleton.vue"
export default component.exports